exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\r\n* Add your custom code here.\r\n* This file and any changes you make to it are preserved every time the app is generated.\r\n*/", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/modules/transparentnost/racuni/racuni.view.component.css
// module id = ../../../../../src/app/modules/transparentnost/racuni/racuni.view.component.css
// module chunks = main